var bookshelf = require("../index-extended"); // ???: ..

module.exports = bookshelf.model("LicenceLimit", {
  tableName: "licence_limit",
});
